export default function (text, targetEl) {
    const announceEl = targetEl ?? document.getElementById('drupal-live-announce');

    if (announceEl) {
        announceEl.innerHTML = '';
        setTimeout(() => {
            announceEl.innerHTML = '';
            setTimeout(() => { announceEl.innerHTML = text }, 50)
        }, 50);
    }
}